// Endereços do app. Navegação e rotas usam estas constantes, nunca a string solta.
// Admin tem os seus em Pages/Admin/adminPaths.ts.
export const PATHS = {
  root: "/",
  // Registrado no Auth0 como redirect_uri: não renomear.
  authCallback: "/auth-callback",
  signup: "/cadastro",
  onboarding: "/boas-vindas",
  newOrder: "/novo-pedido",
  procedures: "/procedimentos",
  opme: "/opme",
  surgicalIndication: "/indicacao-cirurgica",
  orderReview: "/revisar-pedido",
  patientData: "/dados-paciente",
  savedOrders: "/pedidos-salvos",
  appeals: "/recursos",
  settings: "/configuracoes",
  plans: "/planos",
  checkout: "/assinar",
  // Retorno do Stripe Checkout, montado pelo backend: não renomear.
  checkoutConfirming: "/assinatura/confirmando",
  accessInvite: "/entrar",
  admin: "/admin",
} as const;

export const checkoutPath = (plan: string) => `${PATHS.checkout}?plano=${encodeURIComponent(plan)}`;
export const paymentInvitePath = (token: string) => `${PATHS.checkout}/${encodeURIComponent(token)}`;

/** Endereços antigos → novos. Favoritos e links já enviados continuam abrindo a tela. */
export const RENAMED_PATHS: Record<string, string> = {
  "/checkbox": PATHS.procedures,
  "/downloadpdf": PATHS.orderReview,
  "/get-metadatas": PATHS.onboarding,
  "/config": PATHS.settings,
};
